import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';


import { SupervisoresComponent } from './supervisores/supervisores.component';
import { TablaSupervisoresComponent } from './components/tabla-supervisores/tabla-supervisores.component';
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../../shared/services/auth/role-guard.service";

const routes = [
  {
      path: "supervisores",
      component: SupervisoresComponent,
      canActivate: [AuthGuard, RoleGuardService],
      data: {
          allowedRoles: [1],
      },
  }]

@NgModule({
  declarations: [SupervisoresComponent, TablaSupervisoresComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FuseSharedModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,

    MatDialogModule,
    MatToolbarModule,
    MatTabsModule,
    MatListModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatCheckboxModule

  ]
})
export class SupervisoresModule { }
